/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestRetailerContactUpdateRequestBody
 */
export interface RequestRetailerContactUpdateRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    websiteUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    shopUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    twitterUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    facebookUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    youtubeUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    instagramUrl: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRetailerContactUpdateRequestBody
     */
    twitchUrl: string;
}

/**
 * Check if a given object implements the RequestRetailerContactUpdateRequestBody interface.
 */
export function instanceOfRequestRetailerContactUpdateRequestBody(value: object): value is RequestRetailerContactUpdateRequestBody {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('websiteUrl' in value) || value['websiteUrl'] === undefined) return false;
    if (!('shopUrl' in value) || value['shopUrl'] === undefined) return false;
    if (!('twitterUrl' in value) || value['twitterUrl'] === undefined) return false;
    if (!('facebookUrl' in value) || value['facebookUrl'] === undefined) return false;
    if (!('youtubeUrl' in value) || value['youtubeUrl'] === undefined) return false;
    if (!('instagramUrl' in value) || value['instagramUrl'] === undefined) return false;
    if (!('twitchUrl' in value) || value['twitchUrl'] === undefined) return false;
    return true;
}

export function RequestRetailerContactUpdateRequestBodyFromJSON(json: any): RequestRetailerContactUpdateRequestBody {
    return RequestRetailerContactUpdateRequestBodyFromJSONTyped(json, false);
}

export function RequestRetailerContactUpdateRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestRetailerContactUpdateRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'phone': json['phone'],
        'websiteUrl': json['websiteUrl'],
        'shopUrl': json['shopUrl'],
        'twitterUrl': json['twitterUrl'],
        'facebookUrl': json['facebookUrl'],
        'youtubeUrl': json['youtubeUrl'],
        'instagramUrl': json['instagramUrl'],
        'twitchUrl': json['twitchUrl'],
    };
}

export function RequestRetailerContactUpdateRequestBodyToJSON(json: any): RequestRetailerContactUpdateRequestBody {
    return RequestRetailerContactUpdateRequestBodyToJSONTyped(json, false);
}

export function RequestRetailerContactUpdateRequestBodyToJSONTyped(value?: RequestRetailerContactUpdateRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phone': value['phone'],
        'websiteUrl': value['websiteUrl'],
        'shopUrl': value['shopUrl'],
        'twitterUrl': value['twitterUrl'],
        'facebookUrl': value['facebookUrl'],
        'youtubeUrl': value['youtubeUrl'],
        'instagramUrl': value['instagramUrl'],
        'twitchUrl': value['twitchUrl'],
    };
}

